import React from "react";
import { NavLink } from "react-router-dom";

function Banner() {
  return (
    <div className="flex md:flex-row flex-col-reverse md:justify-around items-center m-auto w-[85%]">
      <div className="flex flex-col pt-6 md:pt-0 pl-10 pr-10">
        <h3 className="md:text-6xl text-3xl pb-2 font-bold text-primary">
          We Build Your
        </h3>
        <h3 className="md:text-6xl text-3xl font-bold text-primary">Dream</h3>
        <div className="mb-4 mt-4">
          <NavLink to="/shop/category">
            <button className="mr-4 bg-secondary md:text-base text-sm text-white md:p-4 p-3 rounded-lg border-none outline-none">
              Shop Now
            </button>
          </NavLink>
          <NavLink to="/packages">
            <button className="border border-primary md:pt-4 md:pb-4 p-2 pl-10 pr-10 rounded-lg outline-none">
              Hire
            </button>
          </NavLink>
        </div>
      </div>
      <div className="md:w-auto w-full">
        <img src="images/banner1.png" alt="mechanic" />
      </div>
    </div>
  );
}

export default Banner;
